import { type ReactNode, useEffect, useRef } from "react"

export const AwayListener = ({ children, onAway }: { children: ReactNode; onAway: VoidFunction }) => {
  const wrapperRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    function handleClickOutside(event: MouseEvent) {
      if (wrapperRef.current && !wrapperRef.current.contains(event.currentTarget as HTMLDivElement)) {
        onAway()
      }
    }

    document.addEventListener("mousedown", handleClickOutside)
    return () => {
      document.removeEventListener("mousedown", handleClickOutside)
    }
  }, [wrapperRef])

  return <div ref={wrapperRef}>{children}</div>
}
